import { useQuery } from 'react-query';

import UserService from '../../../services/UserService';
import { USER } from '../../constants/queryDefinition';

const useUserList = () => {
  async function getUserList() {
    const userService = UserService.get();
    const userListResponse = await userService.getUsersList();

    return userListResponse;
  }

  const userList = useQuery(USER.USERLIST.KEY, getUserList, {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: USER.USERLIST.REFETCH_INTERVAL,
    staleTime: USER.USERLIST.REFETCH_INTERVAL,
    placeholderData: undefined,
    retry: false
  });

  return userList;
};

export default useUserList;
